<template>
  <div>
    <el-table :data='dataList' max-height='1000' highlight-current-row border>
      <el-table-column type="index" label='序号' min-width='90'></el-table-column>
      <el-table-column prop='COLUMN_NAME' label='列名' min-width='120'></el-table-column>
      <el-table-column prop='DATA_TYPE' label='数据类型' min-width='100'></el-table-column>
      <el-table-column prop='COLUMN_TYPE' label='列类型' min-width='160'></el-table-column>
      <el-table-column prop='COLUMN_KEY' label='主键' min-width='100'></el-table-column>
      <el-table-column prop='COLUMN_COMMENT' label='列注释' min-width='180'></el-table-column>
      <el-table-column prop='EXTRA' label='其他' min-width='140'></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ColumnTable',
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style scoped>

</style>
